// extracted by mini-css-extract-plugin
export default {"badge":"pCa08","test":"yUo84","extended":"BcScq","quiz":"pSE_E","poll":"dHbxY","crossword":"Q9AtF","error":"V5zAH","info":"bc5uQ","employeeProject":"KWK6n","project":"EC_JX"};